import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  WfFileListComponent,
  WfFileListEntry,
} from 'wflow-main-app/src/app/shared/dumb-components/file-list/file-list.component';
import { PeppolAttachment } from '../../../../interfaces/peppol-detail.interface';
import { PEPPOL_XML_CONTENT_TYPE } from '../../peppol-detail-dialog.const';

@Component({
  selector: 'wf-peppol-detail-files',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, WfFileListComponent],
  templateUrl: './peppol-detail-files.component.html',
  styleUrl: './peppol-detail-files.component.scss',
  host: { class: 'wf-peppol-detail-files' },
})
export class PeppolDetailFilesComponent {
  readonly attachments = input.required<readonly PeppolAttachment[]>();
  readonly activeFileName = input<string | null>(null);

  readonly view = output<PeppolAttachment>();
  readonly download = output<PeppolAttachment>();

  protected readonly entries = computed<WfFileListEntry[]>(() =>
    this.attachments().map((attachment) => ({
      id: attachment.name,
      name: attachment.name,
      iconUrl: this.pickIconUrl(attachment),
      downloadable: attachment.contentType !== PEPPOL_XML_CONTENT_TYPE,
    })),
  );

  protected onView(entry: WfFileListEntry): void {
    this.view.emit(this.findAttachment(entry.id));
  }

  protected onDownload(entry: WfFileListEntry): void {
    this.download.emit(this.findAttachment(entry.id));
  }

  private findAttachment(name: string): PeppolAttachment {
    return this.attachments().find((attachment) => attachment.name === name)!;
  }

  private pickIconUrl(attachment: PeppolAttachment): string {
    if (attachment.contentType === PEPPOL_XML_CONTENT_TYPE) {
      return '/assets/images/document-extensions/PEPPOL.svg';
    }

    const parts = attachment.name.split('.');
    const extension = parts.length > 1 ? parts.pop()!.toUpperCase() : '';
    return `/assets/images/document-extensions/${extension || 'default'}.svg`;
  }
}
